import { ReactNode } from 'react';

interface Props {
  children: ReactNode | Array<ReactNode>;
}

const ContainerLayout = ({ children }: Props) => {
  return (
    <div className="flex min-h-screen flex-col px-5 pb-10 md:px-10">
      <div className="container mr-auto flex flex-col gap-y-5 px-0 pb-16 md:gap-y-10">{children}</div>
    </div>
  );
};

export { ContainerLayout };
